{
  "version": 1,
  "asset_id": "476b27ea-d370-46ec-b979-1789e29f82e4",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/476b27ea-d370-46ec-b979-1789e29f82e4/egg-electric.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/476b27ea-d370-46ec-b979-1789e29f82e4/egg-electric.webp",
  "original_filename": "egg-electric.webp",
  "size": 6190,
  "content_type": "image/webp",
  "created_at": "2026-08-06T21:54:10Z"
}
